import { defineMessages } from 'react-intl'

export default defineMessages({
    onDeleteConfirm: {
        id: 'containers.AgenciesPage.components.AgencyMembers.onDeleteConfirm',
        defaultMessage: 'Are you sure you want to remove {display_name}?',
    },
    onHeadChangeConfirm: {
        id: 'containers.AgenciesPage.components.AgencyMembers.onHeadChangeConfirm',
        defaultMessage: 'Are you sure you want to make {display_name} the head of the agency?',
    },
    deleteMemberTitle: {
        id: 'containers.AgenciesPage.components.AgencyMembers.deleteMemberTitle',
        defaultMessage: 'Remove member from agency',
    },
    changeAgencyHeadTitle: {
        id: 'containers.AgenciesPage.components.AgencyMembers.changeAgencyHeadTitle',
        defaultMessage: 'Make member head of agency',
    }
})